import * as React from 'react';
import { renderText } from '../dateneingabe/assistent/assistent_helpers';

export interface ZusatztoolsInfosBeraterProps {
    data: any;
}

export class ZusatztoolsInfosBerater extends React.Component<ZusatztoolsInfosBeraterProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render(): JSX.Element {
        return (
            <div style={{ padding: 20, maxWidth: 840, textAlign: 'justify', overflowY: 'auto', overflowX: 'hidden' }}>
                {renderText('Infos für Berater:innen', this.props.data)}
            </div>
        );
    }
}
